import { z } from 'zod';
import { refersTo } from '../common/refers-to';

export const ImmoosIqLoadedFactSchema = z.object({
  factKey: z.string(),
  occurrence: z.string().nullable(),
  value: z.unknown(),
  status: z.enum(['PROVEN', 'CONTRADICTED']),
  evidence: z.object({ source: z.string(), date: z.string() }),
});

export const LoadImmoosIqDataResponseSchema = z.discriminatedUnion('outcome', [
  z.object({
    outcome: z.literal('LOADED'),
    propertyId: z.uuid(),
    loadedAt: z.iso.datetime(),
    facts: z.array(ImmoosIqLoadedFactSchema).min(1),
  }),
  z.object({ outcome: z.literal('NO_DATA'), propertyId: z.uuid() }),
]);
export type LoadImmoosIqDataResponse = z.infer<typeof LoadImmoosIqDataResponseSchema>;

export const ImmoosIqLoadStatusResponseSchema = z.object({
  propertyId: refersTo('property', z.uuid()),
  lastLoadedAt: z.iso.datetime().nullable(),
});
export type ImmoosIqLoadStatusResponse = z.infer<typeof ImmoosIqLoadStatusResponseSchema>;
